<!-- <label class="content-que-label">{{question?.question}}</label>
<div class="row imgPopup" *ngIf="question.questionImage != null">
  <img src="data:image/png;base64,{{question.questionImage}}" style="width:90px;height:70px" >
</div> -->
<div class="" style="margin-top: 2%">
  <div class="">
    <!-- <div class="panel-heading">
          <h3 class="panel-title" style="color:white;">Options</h3>   
      </div> -->
    <!-- <table class="table-borderless" style="overflow-x: hidden">
      <tr
        *ngFor="let option of question?.questionOptions; let i = index"
      >
        <td
          *ngIf="
            question?.questionType == 'Radio Button' ||
            question?.questionType == 'RADIO'
          "
          style="border: none !important"
        >

          <mat-radio-button
            class="tp-radio-button"
            [name]="'Radio'"
            [value]="option?.optionCode"
            (change)="onChange(i, $event, question.questionType)"
            [checked]="option.checked"
          >
            <span class="text-black fw-normal">{{ option.optionCode }}. {{
              option.optionValue
            }}</span>
          </mat-radio-button>
        </td>
        <td
          *ngIf="
            question?.questionType == 'Check Box' ||
            question?.questionType == 'CHECKBOX'
          "
          style="border: none !important"
        >
          <section style="color: black">
            <mat-checkbox
              (change)="onChange(i, $event, question.questionType)"
              [name]="option?.optionCode"
              [checked]="option.checked"
              [value]="option?.optionCode"
            >
              <span  class="text-black fw-normal">{{ option.optionCode }}. {{
                option.optionValue
              }}</span></mat-checkbox
            >
          </section>
        </td>
      </tr>
    </table> -->

    <div class="table-borderless" style="overflow-x: hidden">
      <div
        *ngFor="let option of question?.questionOptions; let i = index"
      >
        <div
          *ngIf="
            question?.questionType == 'Radio Button' ||
            question?.questionType == 'RADIO'
          "
          class="options_block"
        >
          <!-- <mat-radio-group class = "tp-radio-group" style="color: black;"> -->
    
        <div class="ps-4 py-2">
          <mat-radio-button
            class="tp-radio-button"
            [name]="'Radio'"
            [value]="option?.optionCode"
            (change)="onChange(i, $event, question.questionType)"
            [checked]="option.checked"
          >
            <span class="text-black fw-normal">{{ option.optionCode }}. {{
              option.optionValue
            }}</span>
          </mat-radio-button>
        </div>
          <!-- </mat-radio-group> -->
        </div>
        <div
          *ngIf="
            question?.questionType == 'Check Box' ||
            question?.questionType == 'CHECKBOX'
          "
          class="options_block"
        >
          <div class="ps-4 py-2">
            <mat-checkbox
              (change)="onChange(i, $event, question.questionType)"
              [name]="option?.optionCode"
              [checked]="option.checked"
              [value]="option?.optionCode"
            >
              <span  class="text-black fw-normal">{{ option.optionCode }}. {{
                option.optionValue
              }}</span></mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <!-- <div *ngIf="question?.questionType =='Radio Button' || question?.questionType =='RADIO'">
        <mat-radio-group class = "tp-radio-group" style="display: flex;flex-direction: column;color: black;">
          
          <mat-radio-button style="height: 25px;margin-left: 3%;" class = "tp-radio-button"
             *ngFor = "let option of question?.questionOptions; let i = index" [name]="option?.optionCode" [value] = "option?.optionCode" 
             (change)="onChange(i,$event,question.questionType)" [checked]="option.checked">
             <span style="color: gray;font-size: 15px;margin-left: -120%;">{{option.optionCode}}.</span>
             <span style="color: gray;font-size: 15px;margin-left: 75%;">{{option.optionValue}}</span>
          </mat-radio-button>
        </mat-radio-group>
        </div> -->
    <!-- <div *ngIf="question?.questionType =='Check Box' || question?.questionType =='CHECKBOX'">
          <section  *ngFor="let option of question?.questionOptions; let i = index" style="display: flex;flex-direction: column;color:black;">
            <span style="color: gray;font-size: 15px;">{{option.optionCode}}.</span>
            <mat-checkbox  style="height: 25px;" (change)="onChange(i,$event,question.questionType)" [name]="option?.optionCode" [checked]="option.checked"  [value]="option?.optionCode">
              <span style="color: gray;font-size: 15px;">{{option.optionValue}}</span></mat-checkbox>
          </section>
        </div> -->
  </div>
</div>
<!-- <div *ngIf="question?.questionType =='Radio Button' || question?.questionType =='RADIO'">
<mat-radio-group class = "tp-radio-group" style="display: flex;flex-direction: column;">
  <mat-radio-button class = "tp-radio-button"
     *ngFor = "let option of question?.questionOptions; let i = index" [name]="option?.optionCode" [value] = "option?.optionCode" 
     (change)="onChange(i,$event,question.questionType)" [checked]="option.checked">
     {{option.optionValue}}
  </mat-radio-button>
</mat-radio-group>
</div>
<div *ngIf="question?.questionType =='Check Box' || question?.questionType =='CHECKBOX'">
  <section  *ngFor="let option of question?.questionOptions; let i = index" style="display: flex;flex-direction: column;">
    <mat-checkbox (change)="onChange(i,$event,question.questionType)" [name]="option?.optionCode" [checked]="option.checked"  [value]="option?.optionCode">{{option.optionValue}}</mat-checkbox>
  </section>
</div> -->

<!-- <label *ngFor="let option of question?.questionOptions; let i = index" style="font-weight: 400 !important;">
  <div > 
    <input style="margin-left:5px;width: 15px !important;height: 15px !important;margin-top:3px !important"
    type="checkbox" 
    [name]="option?.optionCode"
    [value]="option?.optionCode"
    (change)="onChange(i,$event)"
    [checked]="option.checked">

      {{option?.optionValue}}
  </div>
</label> -->


